<div class="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable" role="document">
	<div class="modal-content">
		<div class="modal-header">
			<h5 class="modal-title"><%- Anvil.moment(date).format('YYYY. MM. DD.') %></h5>
			<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
		</div>
		<div class="modal-body">

			<div class="row">

				<div class="col-4">
					<h5 style="font-size:0.9rem;">Naptári napi forgalom</h5>
					<div class="grid-wrapper" style="height:auto;">
						<table class="table table-sm grid-table">
							<thead>
								<td>Típus</td>
								<td class="text-end">Darabszám</td>
								<td class="text-end">Érték</td>
							</thead>
							<tbody>
								<tr>
									<td>Rendelések</td>
									<td class="text-end"><%- day.calendar_day.orders.count %></td>
									<td class="text-end"><%- Anvil.numeral(day.calendar_day.orders.turnover).format('0,0') %></td>
								</tr>
								<tr>
									<td>Bizonylatok</td>
									<td class="text-end"><%- day.calendar_day.receipts.count %></td>
									<td class="text-end"><%- Anvil.numeral(day.calendar_day.receipts.turnover).format('0,0') %></td>
								</tr>
								<tr>
									<td>Rendelés / bizonylat arány</td>
									<td class="text-end"><%- day.calendar_day.receipts.count && day.calendar_day.orders.count ? (day.calendar_day.receipts.count == day.calendar_day.orders.count ? '=' : Anvil.numeral(day.calendar_day.receipts.count - day.calendar_day.orders.count).format('+0,0')) : '-' %></td>
									<td class="text-end"><%- day.calendar_day.receipts.turnover && day.calendar_day.orders.turnover ? Anvil.numeral(day.calendar_day.receipts.turnover / day.calendar_day.orders.turnover).format('0,0%') : '-' %></td>
								</tr>
								<tr>
									<td>Átlagos kosárérték</td>
									<td class="text-end"></td>
									<td class="text-end"><%- Anvil.numeral(day.calendar_day.avg_order).format('0,0') %></td>
								</tr>
							</tbody>
						</table>
					</div>

					<h5 class="mt-3" style="font-size:0.9rem;">NTAK tárgynapi jelentések</h5>
					<div class="grid-wrapper" style="height:auto;">
						<table class="table table-sm grid-table">
							<thead>
								<td>Jelentés</td>
								<td class="text-end">Várakozik</td>
								<td class="text-end">Jelentett</td>
								<td class="text-end">Hibás</td>
							</thead>
							<tbody>
								<tr>
									<td>Rendelés összesítő / nyugta</td>
									<td class="text-end"><%- day.subject_day.receipts.unsent > 0 ? `<span class="text-warning">${day.subject_day.receipts.unsent}</span>` : 0 %></td>
									<td class="text-end"><%- day.subject_day.receipts.submitted %></td>
									<td class="text-end"><%- day.subject_day.receipts.failed > 0 ? `<span class="text-danger">${day.subject_day.receipts.failed}</span>` : 0 %></td>
								</tr>
								<tr>
									<td>Nap zárás</td>
									<td class="text-end"><%- day.subject_day.day_reports.unsent > 0 ? `<span class="text-warning">${day.subject_day.day_reports.unsent}</span>` : 0 %></td>
									<td class="text-end"><%- day.subject_day.day_reports.submitted %></td>
									<td class="text-end"><%- day.subject_day.day_reports.failed > 0 ? `<span class="text-danger">${day.subject_day.day_reports.failed}</span>` : 0 %></td>
								</tr>
							</tbody>
						</table>
					</div>
					<% if (day.subject_day.day_reports.total == 0 && day.subject_day.receipts.total == 0) { %>
					<div class="alert alert-dark overflow-hidden p-2 mt-3">
						<small>
							<p><strong>Ezen a napon nem volt zárás és beérkezett nyugta sem.</strong></p>
							<p>Lehetséges, hogy az üzlet zárva volt, de az is lehetséges, hogy internet kimaradás vagy egyéb technikai probléma lépett fel, ami miatt nem érkeztek adatok.</p>
							<button class="btn btn-primary float-end" onclick="Anvil.page.modal.confirmClosed()"><i class="fa fa-door-closed me-2"></i>Megerősítem, zárva volt</button>
						</small>
					</div>
					<% } %>
				</div>

				<div class="col">

				</div>
			</div>
		</div>
	</div>
</div>
<script>
Anvil.page.modal = Object.assign(Anvil.page.modal, {

	async confirmClosed () {
		const res = await Anvil.exec('c_order/storage/action_confirm_closed_day', Anvil.page.company_db.db_name, Anvil.page.company_db.webapi_authcode, Anvil.page.site.id, Anvil.page.storage.id, Anvil.page.modal.date)

		if (res === true) {

			// Refresh calendar
			if ('refresh' in Anvil.page) {
				Anvil.page.refresh()
			}

			// Close modal
			Anvil.page.modal.close()
		}
	}
})
</script>
